/**
 * Tiny class-name joiner. Filters out falsy values so callers can use boolean
 * shorthand: `cn('btn', isPrimary && 'btn-primary')`.
 */
export const cn = (...classes: (string | false | null | undefined)[]): string =>
  classes.filter(Boolean).join(' ');
